import {
  INSTAGRAM_VIDEO_LIST_REQUEST,
  INSTAGRAM_VIDEO_LIST_SUCCESS,
  INSTAGRAM_VIDEO_LIST_FAIL,
} from "../Constants/InstagramVideoConstants";

const initialState = {
  loading: false,
  videos: [],
  fetchedAt: null,
  error: null,
};

export const instagramVideoStoreListReducer = (
  state = initialState,
  action
) => {
  switch (action.type) {
    case INSTAGRAM_VIDEO_LIST_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };

    case INSTAGRAM_VIDEO_LIST_SUCCESS:
      return {
        ...state,
        loading: false,
        videos: action.payload,
        fetchedAt: Date.now(),
      };

    case INSTAGRAM_VIDEO_LIST_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    default:
      return state;
  }
};
